// extracted by mini-css-extract-plugin
export default {"referrals":"noResult_referrals__RszGw","referral":"noResult_referral__mUeJT","location":"noResult_location__yp38P"};